import React, { useEffect, useState } from 'react';
import { moodboardService } from '../lib/moodboardService';
import { RoomCategory } from '../types/moodboard';

const RoomCategoryManager: React.FC = () => {
  const [categories, setCategories] = useState<RoomCategory[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [newCategoryName, setNewCategoryName] = useState('');

  const fetchCategories = async () => {
    try {
      setLoading(true);
      const categoryList = await moodboardService.getRoomCategories();
      setCategories(categoryList);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An unknown error occurred');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleAddCategory = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!newCategoryName.trim()) {
      return;
    }

    try {
      await moodboardService.addRoomCategory(newCategoryName);
      setNewCategoryName('');
      fetchCategories(); // Refresh the list
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An unknown error occurred');
    }
  };

  if (loading) return <p>Loading categories...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div className="bg-white shadow rounded-lg p-4 mt-6">
      <h3 className="text-lg font-semibold mb-2">Room Categories</h3>
      <form onSubmit={handleAddCategory} className="flex items-center space-x-2 mb-4">
        <input
          type="text"
          value={newCategoryName}
          onChange={(e) => setNewCategoryName(e.target.value)}
          placeholder="New category name"
          className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
        />
        <button type="submit" className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
          Add
        </button>
      </form>
      <ul className="divide-y divide-gray-200">
        {categories.map((category) => (
          <li key={category.id} className="py-2">{category.name}</li>
        ))}
      </ul>
    </div>
  );
};

export default RoomCategoryManager; 